import { SharedPortalService } from './../../../../../components/user-dashboard/portal/shared-portal.service';
import { FunnelTemplateItem } from './../../../../../components/user-dashboard/portal/portal.model';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import {
  LearmoModalRef,
  LearmoModalService,
} from '../../../../../shared/services/learmo-modal.service';

export enum InvitationCurrentStepEnum {
  input = 'input',
  result = 'result',
}
@Component({
  selector: 'app-funnel-item-info-popup',
  templateUrl: './funnel-item-info-popup.component.html',
  styleUrls: ['./funnel-item-info-popup.component.css'],
})
export class FunnelItemInfoPopupComponent implements OnInit {
  @Input() selected: boolean = false;
  @Input() onClickUsePopup: EventEmitter<FunnelTemplateItem> =
    new EventEmitter<FunnelTemplateItem>();

  @Input() item: FunnelTemplateItem;

  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @ViewChild('modalFooter') modalFooter: TemplateRef<any>;
  @Input() modalRef: LearmoModalRef;
  constructor(
    private modalService: LearmoModalService,
    public sharedPortalService: SharedPortalService
  ) {}

  async ngOnInit() {}

  resetModal() {}
  closeModal() {
    this.modalRef.dismiss();
    this.resetModal();
  }

  useActionPopup() {
    this.onClickUsePopup.emit(this.item);
  }
  // Modal Open
  async open(content?) {
    this.onOpenModal();
    this.modalRef = this.modalService.open(this.modalContent, {
      title: 'Funnel Details',
      footer: this.modalFooter,
      premium: true,
      size: 'xl',
    });
  }

  async onOpenModal() {
    // this.resetForm();
    // this.productObject.type_id = 1;
  }
}
